/* eslint-disable no-console */  
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (registration) { 
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log(registration);
      console.log('Service worker has been registered.')
    },
    cached (registration) {
      console.log(registration);
      console.log('Content has been cached for offline use.')
    },
    updatefound (registration) {
      console.log(registration);
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      window.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    },
    offline () {
      window.dispatchEvent(new CustomEvent('offlineMode', {}));
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
